import React, { Component } from 'react';

import "./css/engagcard.css";

class Engagcard extends Component {

    render() {
        return (
            <div className="card-engag">
                <div className="card-body">
                    <h5 className="card-title">{this.props.title}</h5>
                    <p className="card-text">{this.props.description}</p>
                </div>
            </div>
        );
    }
}

export default Engagcard;